import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Store } from '@ngrx/store';
import { takeUntil, take } from 'rxjs/operators';
import { combineLatest, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { SuperTask, VisaTypeList, DEPENDENT_VISAS, ImagilityBaseResponse } from 'app-models';
import { StepStatusUpdatePayloadService } from 'step-status-update-payload-service';
import { loadSubTaskDetails } from 'visa-store';
import { CreateTaskService } from 'src/app/modules/superTask/components/create-task/create-task.service';
import { LookupService } from 'src/app/services/lookup-data.service';
import { ApiServicesService } from 'src/app/modules/beneficiary/services/api-services.service';
import * as fromTask from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import { PetitionerService } from 'src/app/services/petitioner.service';

@Component({
  selector: 'app-add-additional-details',
  templateUrl: './add-additional-details.component.html',
  styleUrls: ['./add-additional-details.component.scss']
})
export class AddAdditionalDetailsComponent implements OnInit, OnDestroy {
  inputData: any;
  guardSubscription: any;
  destroy$ = new Subject<void>();
  formChangesSubscriptions: any[] = [];
  userType = '';
  newTaskForm: FormGroup;
  taskAdditionalDetailsForm: FormGroup;
  jsonInput: FormGroup = new FormGroup({});
  newTaskFromTemplateForm: FormGroup = new FormGroup({
    'jsonInput': this.jsonInput,
    questionAndResponseDTO: this.fb.array([])
  });
  superTask: SuperTask;
  task: any;
  taskType: any;
  OVisaTypeArray = ['O1A', 'O1B'];
  visaTypeArray = VisaTypeList;
  dependentVisaArray = DEPENDENT_VISAS;
  isVDTask: boolean = false;
  taskJson = null;
  beneficiaryList: any[] = [];
  subTaskType: any;
  visaTemplateJson = null;
  i485SuperTask: any;
  ds160SuperTask: any;
  reSuperTask: any;
  constructor(
    private fb: FormBuilder,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
    protected store: Store<any>,
    private stepStatusUpdatePayloadService: StepStatusUpdatePayloadService,
    private toastr: ToastrService,
    private createTaskService: CreateTaskService,
    private lookupService: LookupService,
    private petitionerService: PetitionerService,
    private apiService: ApiServicesService
  ) {
    this.inputData = this.dynamicDialogConfig.data;
    this.userType = sessionStorage.getItem('userTypeRole');
    this.taskAdditionalDetailsForm = this.fb.group({
      companyId: [null],
      isOutsideImagility: [0],
      authorizedSignatoryId: [null],
      petitionType: [null],
      taskTypeCode: [null],
      visaType: [null]
    });
    this.newTaskForm = this.fb.group({
      taskType: [''],
      visaType: [''],
      petitionType: [''],
      immCategoryCode: [null],
      immClassificationCode: [null],
      companyId: [''],
      beneficiaryId: ['']
    });
  }

  ngOnInit(): void {
    combineLatest([
      this.store.select(fromTask.getI485Details),
      this.store.select(fromTask.getDS160Details),
      this.store.select(fromTask.getREDetails)
    ]).pipe(take(1))
      .subscribe((response: any[]) => {
        this.i485SuperTask = response[0];
        this.ds160SuperTask = response[1];
        this.reSuperTask = response[2];
        if (this.reSuperTask) {
          this.getBeneficiaryList(this.reSuperTask.companyId);
        }
      });

    if (this.inputData && this.inputData.subTask) {
      this.superTask = this.inputData.superTask;
      this.subTaskType = this.superTask.visaType ? this.superTask.visaType.code : this.superTask.immigrationType ? this.superTask.immigrationType.code : this.inputData.subTask?.taskTypeCode;
      this.lookupService.getTask(this.inputData.subTask.id, this.subTaskType).pipe(takeUntil(this.destroy$)).subscribe(res => {
        this.task = res;
        //  console.log("$$$$task",this.task);
        const jsonInputVal = this.task.jsonInput ? JSON.parse(this.task.jsonInput) : null;
        this.taskType = res.taskTypeDetails.visaType && !['DS160', 'PWDEFILE'].includes(res.subTaskTypeCode) ? res.taskTypeDetails.visaType : ((res.taskTypeDetails.immCategoryCode && res.taskTypeDetails.immCategoryCode !== 'GCFLY' && !['I140'].includes(res.subTaskTypeCode)) ? res.taskTypeDetails.immCategoryCode : res.subTaskTypeCode);
        this.isVDTask = (res && res.taskTypeSaveJsonId) ? true : false;
        if (this.isVDTask) {
          this.newTaskFromTemplateForm.addControl('newTaskForm', this.newTaskForm);
          this.newTaskFromTemplateForm.patchValue({
            newTaskForm: {
              taskType: this.task?.superTaskTypeCode,
              visaType: this.task?.taskTypeDetails?.visaType,
              petitionType: this.task?.taskTypeDetails?.petitionType,
              immCategoryCode: this.task?.taskTypeDetails?.immCategoryCode,
              immClassificationCode: this.task?.taskTypeDetails?.immClassificationCode
            }
          });

          this.createTaskService.getVisaTemplateJSON(res.taskTypeSaveJsonId)
          .pipe(take(1))
          .subscribe((res: any) => {
            this.visaTemplateJson = res || null;
            if(res.taskJson){
              const jsonObj = JSON.parse(res.taskJson);
              this.taskJson = jsonObj.filter((el)=> !['VdH4TaskDetailsComponent','TaskDetailsComponent'].includes(el.controlName));
              if(['P1A','P1B'].includes(this.task?.taskTypeDetails?.visaType)){
                this.taskJson = this.taskJson.filter((el)=> !['VdSwitchGroupComponent'].includes(el.controlName));
              }
            }
            //this.taskJson = (res.taskJson) ? JSON.parse(res.taskJson) : null;
            setTimeout(() => {
              this.userType == 'Beneficiary' ? this.newTaskForm.get('beneficiaryId').setValue(sessionStorage.getItem('beneficiaryId')) : this.newTaskForm.get('beneficiaryId').setValue(this.task.beneficiaryId);
              this.newTaskForm.get('companyId').setValue(this.task.companyId);
              if(jsonInputVal){
                this.newTaskFromTemplateForm.patchValue({
                  jsonInput:{
                    ... jsonInputVal,
                  }
                });
              }
              //this.taskJson = (res.taskJson) ? JSON.parse(res.taskJson) : null;
         
              }, 1000);
            });
        } else {
          this.taskAdditionalDetailsForm.patchValue({
            companyId: res?.companyId,
            isOutsideImagility: res?.isOutsideImagility,
            petitionType: res?.taskTypeDetails?.petitionType,
            taskTypeCode: res?.subTaskTypeCode,
            visaType: res?.taskTypeDetails?.visaType,
            authorizedSignatoryId: res?.signatoryId
          });
        }
      });
      //  console.log("$$$ this.newTaskFromTemplateForm",this.newTaskFromTemplateForm);
    }


  }

  handleClose() {
    this.dynamicDialogRef.close();
  }

  getBeneficiaryList(companyId, searchText: string = '') {
    const beneficiaryParamPayload = {
      pageNumber: 1,
      recordsPerPage: 100,
      searchCriteria: 'beneficiary',
      searchText: searchText,
      sortBy: 'companyName',
      sortOrder: 'asc',
      status: ['ACTIVE']
    };
    this.apiService.getBeneficiariesByCompanyId(companyId, beneficiaryParamPayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: Array<any>) => {
        if (data) {
          this.beneficiaryList = data.map((ben) => { ben['fullName'] = `${ben.beneficiaryEmployeeFName}${ben.beneficiaryEmployeeMName ? ' ' + ben.beneficiaryEmployeeMName : ''} ${ben.beneficiaryEmployeeLName}`; return ben; });
        }
      });
  }

  saveAdditionalDetails() {
    let subtaskForm;
    const taskFormValue = this.isVDTask ? {} : this.taskAdditionalDetailsForm.value;
    const questionAndResponseDTO = taskFormValue.questionAndResponseDTO && taskFormValue.questionAndResponseDTO.length > 0 ?
      taskFormValue.questionAndResponseDTO.map(x => {
        return {
          ...x,
          answer: x.answer ? 1 : 0
        };
      }) : [];

    if (taskFormValue.length && taskFormValue.isInterpreterReqd && taskFormValue.interpreterLangId && taskFormValue.interpreterId && taskFormValue.interpreterLanguageId) {
      this.petitionerService.interpreterInfo$.next({ 'isInterpreterReqd': taskFormValue.isInterpreterReqd, 'interpreterLangId': taskFormValue.interpreterLangId, 'interpreterId': taskFormValue.interpreterId, 'interpreterLanguageId': taskFormValue.interpreterLanguageId });
    }

    if (this.visaTypeArray.includes(this.task.taskTypeDetails.visaType) && !['DS160', 'PWDEFILE'].includes(this.taskType) && !this.OVisaTypeArray.includes(this.task.taskTypeDetails.visaType) && !this.isVDTask) {
      subtaskForm = {
        attorneyId: taskFormValue.attorneyId,
        authorizedSignatoryId: taskFormValue.authorizedSignatoryId,
        beneficiaryId: this.task.beneficiaryId,
        companyId: this.task.companyId,
        id: this.task.id,
        immSpecialistId: taskFormValue.immSpecialistId,
        immigrantTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immigrationType : null,
        isOutsideImagility: this.task.isOutsideImagility,
        petitionTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.petitionType : null,
        preparerAttorneyId: taskFormValue.preparerAttorneyId,
        questionAndResponseDTO,
        processingType: taskFormValue.processingType,
        serviceCenterId: taskFormValue.serviceCenterId,
        superTaskId: this.task.superTaskId,
        superTaskTypeCode: this.task.superTaskTypeCode,
        taskTypeCode: this.task?.subTaskTypeCode,
        visaTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.visaType : null,
        companyRelationCode: taskFormValue.companyRelationCode,
        foreignCompanyId: taskFormValue.foreignCompanyId,
        interpreterId: taskFormValue?.interpreterId,
        interpreterLangId: taskFormValue?.interpreterLangId,
        interpreterLanguageId: taskFormValue?.interpreterLanguageId,
        isInterpreterReqd: taskFormValue?.isInterpreterReqd,
        lawFirmUsers: taskFormValue?.lawFirmUsers,
        beneficiaryType: taskFormValue?.beneficiaryType ? taskFormValue?.beneficiaryType : null
      };
    } else if (this.OVisaTypeArray.includes(this.task.taskTypeDetails.visaType) && !['DS160', 'PWDEFILE'].includes(this.taskType)) {
      subtaskForm = {
        id: this.task.id,
        attorneyId: taskFormValue.attorneyId,
        authorizedSignatoryId: taskFormValue.authorizedSignatoryId,
        beneficiaryId: this.task.beneficiaryId,
        companyId: this.task.companyId,
        immSpecialistId: taskFormValue.immSpecialistId,
        immigrantTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immigrationType : null,
        isOutsideImagility: this.task.isOutsideImagility,
        petitionTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.petitionType : null,
        preparerAttorneyId: taskFormValue.preparerAttorneyId,
        questionAndResponseDTO,
        processingType: taskFormValue.processingType,
        serviceCenterId: taskFormValue.serviceCenterId,
        superTaskId: this.task.superTaskId,
        superTaskTypeCode: this.task.superTaskTypeCode,
        taskTypeCode: this.task?.subTaskTypeCode,
        visaTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.visaType : null,
        extrAblDocEvdCatgCode: taskFormValue?.extrAblDocEvdCatgCode ? taskFormValue?.extrAblDocEvdCatgCode : this.task.extrAblDocEvdCatg.code,
        fieldExtrAbltyCode: taskFormValue?.fieldExtrAbltyCode ? taskFormValue?.fieldExtrAbltyCode : this.task.fieldExtrAblty.code,
        applicableOptionCodes: taskFormValue?.applicableOptionCodes ? taskFormValue?.applicableOptionCodes : this.task.extrAblDocEvdList,
        interpreterId: taskFormValue?.interpreterId,
        interpreterLangId: taskFormValue?.interpreterLangId,
        interpreterLanguageId: taskFormValue?.interpreterLanguageId,
        isInterpreterReqd: taskFormValue?.isInterpreterReqd,
        lawFirmUsers: taskFormValue?.lawFirmUsers,
        beneficiaryType: taskFormValue?.beneficiaryType ? taskFormValue?.beneficiaryType : null,
        ownershipInterestInPetitionOrg: taskFormValue?.ownershipInterestInPetitionOrg,
        explanationownershipInterestInPetitionOrg: taskFormValue?.explanationownershipInterestInPetitionOrg
      };
    } else if (this.taskType === 'I130') {
      subtaskForm = {
        attorneyId: taskFormValue.attorneyId,
        authorizedSignatoryId: taskFormValue.authorizedSignatoryId,
        beneficiaryId: null,
        companyId: null,
        id: this.task.id,
        immSpecialistId: taskFormValue.immSpecialistId,
        immigrantTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immigrationType : null,
        isOutsideImagility: this.task.isOutsideImagility,
        petitionTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.petitionType : null,
        preparerAttorneyId: taskFormValue.preparerAttorneyId,
        questionAndResponseDTO,
        processingType: taskFormValue.processingType,
        serviceCenterId: taskFormValue.serviceCenterId,
        superTaskId: this.task.superTaskId,
        superTaskTypeCode: 'IMMPET',
        taskTypeCode: this.taskType,
        visaTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.visaType : null,
        familyId: this.task.familyId,
        immCategoryCode: this.superTask.immigrationCategory ? this.superTask.immigrationCategory.code : null,
        immClassificationCode: this.superTask.immigrationClassification ? this.superTask.immigrationClassification.code : null,
        sponsorId: this.task.sponsorId,
        interpreterId: taskFormValue?.interpreterId,
        interpreterLangId: taskFormValue?.interpreterLangId,
        interpreterLanguageId: taskFormValue?.interpreterLanguageId,
        isInterpreterReqd: taskFormValue?.isInterpreterReqd,
        lawFirmUsers: taskFormValue?.lawFirmUsers,
        beneficiaryType: taskFormValue?.beneficiaryType ? taskFormValue?.beneficiaryType : null,
        filingType: taskFormValue?.filingType ? taskFormValue.filingType : null
      };
    } else if (this.isVDTask) {
      const formData = [];
      subtaskForm = {};
      Object.keys(this.newTaskFromTemplateForm.controls).forEach((key, i) => {
        if (!['jsonInput', 'questionAndResponseDTO'].includes(key)) {
          formData.push(this.newTaskFromTemplateForm.controls[key].value);
          if (this.newTaskFromTemplateForm.controls[key] instanceof FormGroup || this.newTaskFromTemplateForm.controls[key] instanceof FormArray) {
            Object.assign(subtaskForm, this.newTaskFromTemplateForm.controls[key].value);
          } else {
            const keyProp = key;
            Object.assign(subtaskForm, { [keyProp]: this.newTaskFromTemplateForm.controls[key].value });
          }
        }
      });
      subtaskForm.jsonInput = this.newTaskFromTemplateForm.get('jsonInput').value ? this.newTaskFromTemplateForm.get('jsonInput').value : null;
      if (subtaskForm.jsonInput) {
        if (subtaskForm.jsonInput.applicantsList && subtaskForm.jsonInput.applicantsList.length > 0) {
          subtaskForm.jsonInput.applicantsList = (subtaskForm.jsonInput.applicantsList).filter(item => item.isChecked);
          // if(subtaskForm.jsonInput?.isSpouseChildPetitionInclude === false ){
          //   subtaskForm.jsonInput.applicantsList = (subtaskForm.jsonInput.applicantsList).filter(item => item.isChecked);
          // }else{
          //   subtaskForm.jsonInput.applicantsList = [];
          // }       
        } else {
          if (subtaskForm.jsonInput.primaryApplicant) {
            subtaskForm.jsonInput.applicantsList = [subtaskForm.jsonInput.primaryApplicant];
          }
        }

        if (subtaskForm.jsonInput.primaryApplicant) {
          subtaskForm.jsonInput.primaryApplicant.isPrimaryApplicant = true;
          subtaskForm.jsonInput.primaryApplicant.primaryApplicant = true;

        }
      }
      if (subtaskForm.jsonInput) {
        subtaskForm.jsonInput = JSON.stringify(subtaskForm.jsonInput);
      }
      // if (this.newTaskFromTemplateForm.controls['questionAndResponseDTO'].value) {
      //   subtaskForm.questionAndResponseDTO = this.newTaskFromTemplateForm.controls['questionAndResponseDTO'].value.map((item) => {
      //     item.answer = item.answer ? 1 : 0;
      //     item.additionalInfo = item.additionalInfo !== null ? String(item.additionalInfo) : null;
      //     return item;
      //   });
      // }
      if (subtaskForm.hasOwnProperty('CommonTaskQuestions')) {
        subtaskForm.CommonTaskQuestions.forEach((item) => {
          item.answer = item.answer ? 1 : 0;
          item.additionalInfo = item.additionalInfo !== null ? String(item.additionalInfo) : null;
        });
      }
      subtaskForm.id = this.task.id;
      subtaskForm.immigrantTypeCode = 'VISA';
      subtaskForm.taskTypeCode = this.task.subTaskTypeCode ? this.task.subTaskTypeCode : null;
      subtaskForm.isOutsideImagility = this.task.isOutsideImagility;
      subtaskForm.visaTypeCode = this.task.taskTypeDetails ? this.task.taskTypeDetails?.visaType : null;
      subtaskForm.petitionTypeCode = this.task.taskTypeDetails ? this.task.taskTypeDetails.petitionType : null;
      subtaskForm.taskTypeId = this.task?.taskTypeId;
      subtaskForm.superTaskId = this.task?.superTaskId;
      subtaskForm.questionAndResponseDTO = subtaskForm.questionAndResponseDTO && subtaskForm.questionAndResponseDTO.length > 0 ? subtaskForm.questionAndResponseDTO : (subtaskForm.CommonTaskQuestions && subtaskForm.CommonTaskQuestions.length > 0 ? subtaskForm.CommonTaskQuestions : []);
    } else {
      subtaskForm = {
        attorneyId: taskFormValue.attorneyId,
        authorizedSignatoryId: taskFormValue.authorizedSignatoryId,
        beneficiaryId: this.task.beneficiaryId,
        companyId: this.task.companyId,
        id: this.task.id,
        immSpecialistId: taskFormValue.immSpecialistId,
        immigrantTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immigrationType : null,
        isOutsideImagility: this.task.isOutsideImagility,
        petitionTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.petitionType : null,
        preparerAttorneyId: taskFormValue.preparerAttorneyId,
        questionAndResponseDTO,
        processingType: taskFormValue.processingType,
        serviceCenterId: taskFormValue.serviceCenterId,
        superTaskId: this.task.superTaskId,
        superTaskTypeCode: this.task.superTaskTypeCode,
        taskTypeCode: this.task?.subTaskTypeCode,
        visaTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails?.visaType : null,
        immCategoryCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immCategoryCode : null,
        immClassificationCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immClassificationCode : null,
        companyRelationCode: this.task?.companyRelationCode,
        foreignCompanyId: taskFormValue.foreignCompanyId,
        taskTypeId: this.task.taskTypeId,
        consulate: this.task?.consulate,
        interpreterId: taskFormValue?.interpreterId,
        interpreterLangId: taskFormValue?.interpreterLangId,
        interpreterLanguageId: taskFormValue?.interpreterLanguageId,
        isInterpreterReqd: taskFormValue?.isInterpreterReqd,
        lawFirmUsers: taskFormValue?.lawFirmUsers,
        beneficiaryType: taskFormValue?.beneficiaryType ? taskFormValue?.beneficiaryType : null
      };
    }
    if (subtaskForm.isOutsideImagility === 0) {
      subtaskForm.customStepList = this.task.taskCustomStepDetails.map((step) => { step.taskStepId = step.stepId; return step; });
    }
    // console.log("subtaskForm",subtaskForm);
    // return;
   
    const isGctask = this.inputData.subTask && this.inputData.subTask.taskTypeCode === "I140" ? true : false;
    this.stepStatusUpdatePayloadService.saveUpdateSubTask(subtaskForm, this.taskType, isGctask)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: ImagilityBaseResponse) => {
        if (response) {
          this.toastr.success(response.message, 'Success');
          this.store.dispatch(loadSubTaskDetails({
            taskId: subtaskForm.id,
            visaTypeCode: this.taskType
          }));
          this.dynamicDialogRef.close();
          window.location.reload();
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.formChangesSubscriptions) {
      this.formChangesSubscriptions.forEach(item => { item.unsubscribe(); });
    }
  }

}
